import CreateProductAttributesFormFields from "./CreateProductAttributesFormFields";

const fields = [
  {
    name: "curbWidth",
    label: "Curb Width",
  },
  {
    name: "curbHeight",
    label: "Curb Height",
  },
];

export default function AsphaltCurbingForm() {
  return <CreateProductAttributesFormFields fields={fields} />;
}
